export default {"src":"/_next/static/media/psychologyIcon.4aef501d.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};